// This section name, must match the name coming from partner-orchestrator
export const WEALTH_OVERVIEW_SECTION_NAME = 'Wealth Profile';

export const WEALTH_OVERVIEW_EDIT_HISTORY_HIDDEN_ATTRIBUTES = [
  'BankableAssetItem/id',
  'ExpenseItem/id',
  'IncomeItem/id',
  'LiabilityItem/id',
  'RealEstateAssetItem/id',
  'SourceOfWealthCountry/id',
  'SourceOfWealthIndustry/id',
  'assetSummary/bankableAssets.items',
  'assetSummary/realEstates.items',
  'expensesSummary/generalLivings.items',
  'expensesSummary/realEstates.items',
  'incomeSummary/employments.items',
  'incomeSummary/securities.items',
  'liabilitySummary/mortgages.items',
  'liabilitySummary/otherLiabilities.items',
  'liabilitySummary/privateLoans.items',
  'sourceOfWealth/sourceOfWealthConnection.countries',
  'sourceOfWealth/sourceOfWealthConnection.industries',
  'Event/eventId',
  'sourceOfWealth.events',
  'partnerUid',
  'Evidence/id',
  'evidenceDocument.agreementId',
  'Event/id',
  'occupationEventDetails.positions',
];
